import React, { useId, CSSProperties } from 'react';
import { Typography, Stack, Container, styled, Box } from '@mui/material';
import { ResponsiveSVG } from 'components/ResponsiveSVG/ResponsiveSVG';
import { AccessibleBox } from 'components/AcessibleBox/AcessibleBox';

interface EmptyStateProps {
  imageArray: string[];
  title: string;
  subtitle: string;
  deviceWidth?: { desktop: string; tablet: string; mobile: string };
  style?: CSSProperties;
}
const StyledAcessibleBox = styled(AccessibleBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  gap: theme.spacing(2),
}));
const defaultDeviceWidth = { desktop: '250px', tablet: '235px', mobile: '180px' };

export const EmptyState = ({
  imageArray,
  title,
  subtitle,
  deviceWidth,
  style,
}: EmptyStateProps) => {
  const titleId = useId();
  const subtitleId = useId();
  const randomIndex = Math.floor(Math.random() * (imageArray?.length ?? 1));
  const imageName = imageArray?.[randomIndex];
  const imageWidth = deviceWidth ?? defaultDeviceWidth;
  return (
    <StyledAcessibleBox style={style}>
      {imageName && (
        <ResponsiveSVG svg={imageName} deviceWidth={imageWidth} alt="Empty state illustration" />
      )}
      <Typography id={titleId} textAlign="center" variant="h6" color="primary" aria-level={1}>
        {title}
      </Typography>
      <Typography id={subtitleId} textAlign="center" variant="body1" color="grey.800">
        {subtitle}
      </Typography>
    </StyledAcessibleBox>
  );
};
